(() => {
  'use strict';
  function init() {
    const node = document.getElementById('xikavy-commerce-data');
    if (!node) return;
    const store = JSON.parse(node.textContent);
    const root = store.root.endsWith('/') ? store.root : store.root + '/';
    const catalog = window.XIKAVY?.products || [];
    const product = catalog.find(p => p.id === document.body.dataset.product);
    const form = document.getElementById('commerce-product-form');
    const message = document.getElementById('commerce-product-message');
    let adding = false;
    function setCount(count) {
      document.querySelectorAll('#bag-count,[data-bag-count]').forEach(el => { el.textContent = String(count); el.hidden = count === 0; });
      document.querySelectorAll('[data-bag-link],#bag-open').forEach(el => el.setAttribute('aria-label', `Shopping bag, ${count} ${count === 1 ? 'item' : 'items'}`));
    }
    const money = cents => new Intl.NumberFormat('en-US', {style:'currency', currency:store.currency || 'USD'}).format(cents / 100);
    async function request(path, payload) {
      const response = await fetch(root + path, {method:payload ? 'POST' : 'GET', credentials:'same-origin', headers:{'Accept':'application/json', ...(payload ? {'Content-Type':'application/json'} : {})}, ...(payload ? {body:JSON.stringify(payload)} : {})});
      const result = await response.json();
      if (!response.ok) throw new Error(result.description || result.message || 'Your bag could not be updated. Please try again.');
      return result;
    }
    function notify(text, error = false, link = false) {
      if (!message) return;
      message.textContent = text;
      message.dataset.error = String(error);
      if (link) { const a = document.createElement('a'); a.href = root + 'cart'; a.textContent = 'View bag →'; message.appendChild(a); }
    }
    function currentVariant() {
      if (!product) return null;
      const ci = Number(document.querySelector('[data-color][aria-pressed="true"]')?.dataset.color || 0);
      const color = product.colors[ci]?.name;
      const device = document.querySelector('[data-device][aria-pressed="true"]')?.dataset.device;
      return store.products[product.id]?.variants.find(v => v.color === color && v.device === device) || null;
    }
    function syncVariant(updateURL = true) {
      if (!form) return;
      const variant = currentVariant();
      const selector = document.getElementById('commerce-variant');
      const button = document.getElementById('add-to-bag');
      selector.value = variant ? String(variant.id) : '';
      button.disabled = adding || !variant?.available;
      button.textContent = adding ? 'Adding…' : variant?.available ? 'Add to bag' : 'Unavailable';
      const price = document.querySelector('.pdp-price');
      if (price && variant) price.textContent = money(variant.price);
      if (updateURL && variant) {
        const url = new URL(location.href);
        url.searchParams.set('variant', String(variant.id));
        url.searchParams.delete('selection'); url.searchParams.delete('bagempty');
        history.replaceState(null, '', url.pathname + url.search + url.hash);
      }
      if (!adding) notify(variant?.available ? '' : 'This color and device combination is currently unavailable.');
    }
    document.addEventListener('click', event => {
      if (event.target.closest('[data-color],[data-device]')) syncVariant();
    });
    form?.addEventListener('submit', async event => {
      event.preventDefault();
      if (adding) return;
      const variant = currentVariant();
      if (!variant?.available) { notify('Please choose an available color and device.', true); return; }
      const field = document.getElementById('product-quantity');
      const quantity = Math.min(99, Math.max(1, Math.floor(Number(field.value) || 1)));
      field.value = String(quantity);
      adding = true; form.setAttribute('aria-busy','true'); syncVariant(false);
      notify('Adding to your bag…');
      try {
        await request('cart/add.js', {items:[{id:variant.id,quantity}]});
        // A successful add is already confirmed; a count refresh failure must not invite a duplicate add.
        try { const cart = await request('cart.js'); setCount(cart.item_count); } catch (_) { /* Cart page remains authoritative. */ }
        notify(`${quantity} ${quantity === 1 ? 'item' : 'items'} added to your bag.`, false, true);
      } catch (error) { notify(error.message || 'We could not confirm the update. Check your bag before trying again.', true, true); }
      finally { adding = false; form.removeAttribute('aria-busy'); const button=document.getElementById('add-to-bag'); button.disabled=!currentVariant()?.available; button.textContent=currentVariant()?.available?'Add to bag':'Unavailable'; }
    });
    document.querySelectorAll('.commerce-line-form').forEach(line => {
      line.addEventListener('submit', async event => {
        event.preventDefault();
        if (line.getAttribute('aria-busy') === 'true') return;
        const input = line.querySelector('input[name="quantity"]');
        const quantity = event.submitter?.hasAttribute('data-commerce-remove') ? 0 : Math.min(99,Math.max(0,Math.floor(Number(input.value)||0)));
        line.setAttribute('aria-busy','true');
        document.querySelectorAll('.commerce-checkout,.commerce-line-controls button').forEach(b=>b.disabled=true);
        const errorNode=document.getElementById('commerce-error'); errorNode.hidden=true;
        try { await request('cart/change.js',{id:line.querySelector('input[name="id"]').value,quantity}); location.reload(); }
        catch (error) { errorNode.textContent=error.message || 'Could not update your bag.'; errorNode.hidden=false; line.removeAttribute('aria-busy'); document.querySelectorAll('.commerce-checkout:not([data-payment-pending]),.commerce-line-controls button').forEach(b=>b.disabled=false); }
      });
    });
    setCount(store.count);
    syncVariant(false);
    window.addEventListener('pageshow', event=>{ if(event.persisted)request('cart.js').then(cart=>{if(document.body.dataset.page==='bag')location.reload();else setCount(cart.item_count);}).catch(()=>{}); });
    window.addEventListener('focus',()=>request('cart.js').then(cart=>setCount(cart.item_count)).catch(()=>{}));
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();
})();
